import React from "react";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import API from "@beardeddevops/react.api";
import {feBookableTodayFilter} from "../../constants/feBookable";


export default class Alert extends Framework.Components.Object {
	constructor(props) {

		super(props, Types.Alerts._name);
		this.loadFEs();
	}

	//Grab fes for select dropdown
	async loadFEs() {
		let fes = new API.BuildClass(Types.Tickets._name, API.RequestType.READ_ALL);
		fes.parent = this.state.pkey;

		let data = await fes.submit(null, API.RequestType.READ_ALL);
		this.setState({
			fieldEngineers: data.items
		})
}


	form = () => {
		let {properties} = this.model;
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
			<fieldset>
				<div className={"row"}>
					<div className={"col-md"}>
						<h4 className={"section-title"}>Alert Information</h4>
						<div className={"row"}>
							<div className={"col-12"}>
								<div className="form-group">
									<Framework.Elements.TextField
										property={properties.message}
										value={object.message}
										error={object.message_error}
										update={this.handleTextFieldPropertyUpdate}
										label={'Message'}
										multiline={4}
									/>
								</div>
							</div>
						</div>
							<div className={"row"}>
							<div className={"col-12"}>
								<div className="form-group">
									<Framework.Elements.Select
										 objectKey={this.props.location}
										shouldLoad={true}
										property={properties.user_receiving}
										 label={"User"}
										value={object.user_receiving}
										 error={object.user_receiving_error}
										 object={object.user_receiving}
										update={this.handleSelectPropertyUpdate}
										groupBy={(option) =>
											option.original.region
												? option.original.regions.name
												: "No Region"
										}
										requestOverride={"GET_FIELD_ENGINEERS"}
										filter={feBookableTodayFilter}
										defaultGroup={this.props.location}
										limit={null}
										nullable={true}
										sort={"ranking"}
										text={"name_first&name_last"}
										showToolTip={true}
										default={""}
										 groupSort={(option) => option.original?.regions ? option.original.regions.ranking : 100}

									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</fieldset>
		<Framework.Elements.LoadingSpinner isLoading={loading}/></div>

	)
	}
}
